import React from "react";
import Section from "../../components/section";
import background1 from "./highlight-event-background.svg";
import background2 from "./highlight-event-background-2.svg";

const HighlightEventPage: React.FC = () => {
  return (
    <>
      <Section backgroundImage={background1}>
        <div className="flex items-center justify-center h-screen">
          <div className="container mx-auto px-4">
            <h2 className="text-4xl sm:text-5xl font-bold mb-8 text-center text-white">
              Anchoring Conversations
            </h2>
            <div className="text-center">
              <p className="text-white text-opacity-80 text-xl sm:text-2xl mb-6">
                Our signature Anchoring Conversations provide a unique platform
                where professionals, policymakers, and community members engage
                in intimate discussions. These conversations aim to generate
                actionable insights, promote understanding, and inspire
                collaborative solutions to societal challenges.
              </p>
            </div>
          </div>
          <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bob-up-down">
            <span className="text-4xl">⌄</span>
          </div>
        </div>
      </Section>
      <Section backgroundImage={background2}>
        <div className="flex items-center justify-center h-screen">
          <div className="container mx-auto px-4">
            <h3 className="text-4xl sm:text-5xl font-bold mb-4 text-white text-center">
              Addressing Dementia
            </h3>
            <div className="text-center">
              <p className="text-white text-opacity-80 text-xl sm:text-2xl mb-8">
                Recognizing the challenges posed by an aging society, rippl.sg
                is dedicated to addressing the pressing concern of dementia.
                Through a compelling video series, we illuminate the
                multifaceted aspects of dementia, fostering awareness and
                understanding. Our goal is to dispel myths, advocate for empathy
                and support, and encourage the youth to contribute to building a
                more dementia-friendly Singapore.
              </p>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
};

export default HighlightEventPage;
